interface ReportFilterStateProps {
  title: string;
  message: string;
}

export function ReportFilterState({ title, message }: ReportFilterStateProps) {
  return (
    <div className="flex h-64 items-center justify-center">
      <div className="text-center">
        <h3 className="subtitle text-foreground mb-2">{title}</h3>
        <p className="body text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}
